import { useAuth } from "../../../../../../modules/auth";
import { useDataContext } from "../../../../page/context";
import { useExecutePortalActionMutation } from "../../../../../services/data/portal-action";
import { useFormDataContext } from "../../form";

interface IExecuteFunctionOptions {
    functionName?: string,
    executeSave?: boolean,
    systemId?: string
}

export const useExecuteFormAction = () => {
    const { saveFormData } = useFormDataContext()
    const { user, siteId: portalId } = useAuth();
    const { refetch } = useDataContext()
    const [execute] = useExecutePortalActionMutation()

    const executeFunction = (options: IExecuteFunctionOptions): Promise<void> => {
        const { functionName, executeSave, systemId: sysId } = options

        if (!user || !portalId)
            return Promise.reject('Invalid parameters');

        const { userId } = user

        if (!functionName)
            return Promise.reject('Invalid parameters');

        if (!executeSave)
            return execute({ userId, portalId, functionName, sysId })
                .unwrap()

        const postSaveData = () => execute({ userId, portalId, functionName, sysId })
            .unwrap()

        return saveFormData(postSaveData)
            .then(() => refetch())
    }

    return { executeFunction }
}
